import { register } from '@ravnur/core/ui-kit/icon/icon-storage';

/* eslint max-len: 0 */

register('navigate', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12.3327 2.4987C11.8724 2.4987 11.4993 2.1256 11.4993 1.66536C11.4993 1.20513 11.8724 0.832031 12.3327 0.832031H16.4993C16.9596 0.832031 17.3327 1.20513 17.3327 1.66536V5.83203C17.3327 6.29227 16.9596 6.66536 16.4993 6.66536C16.0391 6.66536 15.666 6.29227 15.666 5.83203V3.67721L8.75527 10.588C8.42983 10.9134 7.9022 10.9134 7.57676 10.588C7.25132 10.2625 7.25132 9.73488 7.57676 9.40944L14.4875 2.4987H12.3327ZM0.666016 3.33203C0.666016 2.87179 1.03911 2.4987 1.49935 2.4987H8.99935C9.45959 2.4987 9.83268 2.87179 9.83268 3.33203C9.83268 3.79227 9.45959 4.16536 8.99935 4.16536H2.33268V15.832H13.9993V9.16536C13.9993 8.70513 14.3724 8.33203 14.8327 8.33203C15.2929 8.33203 15.666 8.70513 15.666 9.16536V16.6654C15.666 17.1256 15.2929 17.4987 14.8327 17.4987H1.49935C1.03911 17.4987 0.666016 17.1256 0.666016 16.6654V3.33203Z',
    },
  ],
});

register('pin', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M6.89496 20.8934V14.6308H1.03276C0.452212 14.6308 0.0351562 14.1158 0.0351562 13.5511C0.0351562 12.9864 0.452212 12.4714 1.03276 12.4714H1.8089L2.76102 1.66208L2.7614 1.65824C2.85192 0.741577 3.55649 -0.000684023 4.44793 5.12255e-05L11.5543 4.62043e-05C12.4402 -0.00667522 13.1442 0.720782 13.2474 1.62901L14.1937 12.4714H14.9703C15.55 12.4714 15.9679 12.9862 15.9679 13.5511C15.9679 14.116 15.55 14.6308 14.9703 14.6308H9.10808V20.8934C9.10808 21.5046 8.61266 22 8.00152 22C7.39038 22 6.89496 21.5046 6.89496 20.8934Z',
    },
  ],
});

register('clock', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z',
    },
  ],
});

register('play-box-outline', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10,8V16L15,12L10,8Z',
    },
  ],
});

register('edit', {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M12.4411 0.953771C13.7125 -0.317924 15.7743 -0.317924 17.0458 0.953771C18.3181 2.22547 18.3181 4.28728 17.0458 5.55897L5.70748 16.8976C5.59375 17.0113 5.44893 17.0887 5.29102 17.1202L0.974314 17.9837C0.404043 18.0976 -0.0975004 17.5954 0.0162264 17.0257L0.879405 12.7084C0.911314 12.5508 0.988223 12.4061 1.10195 12.2924L12.4411 0.953771ZM13.5923 6.71023L11.2899 4.40763L2.07886 13.618L1.50368 16.4962L4.38203 15.9206L13.5923 6.71023ZM15.8946 2.10511C15.2589 1.46922 14.228 1.46922 13.5923 2.10511L12.4411 3.25637L14.7434 5.55897L15.8946 4.40763C16.5303 3.77182 16.5303 2.74092 15.8946 2.10511Z',
    },
  ],
});

register('warning-triangle', {
  width: 64,
  height: 64,
  paths: [
    {
      d: 'M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z',
    },
  ],
});

register('subscriptions', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 8H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1zm-2-6H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm5 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6.81 3.56L10 12.73v6.53l5.19-2.82c.35-.19.35-.69 0-.88z',
    },
  ],
});

register('vert-more', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    },
  ],
});

register('youtube', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M20,8H4V6H20V8M18,2H6V4H18V2M22,12V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V12A2,2 0 0,1 4,10H20A2,2 0 0,1 22,12M16,16L10,12.73V19.26L16,16Z',
    },
  ],
});

register('question', {
  width: 16,
  height: 14,
  paths: [
    {
      d: 'M3.49126 10.3624H3.39126V10.4624V12V12.1H3.49126H4.96237H5.06237V12V10.4624V10.3624H4.96237H3.49126ZM0.9 4.54099V4.64099H1H2.31586H2.41209L2.41579 4.54484C2.44019 3.91028 2.54016 3.43709 2.70761 3.11615L2.70781 3.11576C3.00234 2.54512 3.53211 2.25323 4.32661 2.25323C4.97608 2.25323 5.41612 2.42625 5.67548 2.74822L5.67601 2.74887C5.95132 3.08484 6.08952 3.48102 6.08952 3.9422C6.08952 4.26702 5.99699 4.58172 5.80865 4.88778L5.80864 4.88777L5.80786 4.88908C5.70482 5.06237 5.56806 5.23022 5.39639 5.39235L5.39637 5.39233L5.39479 5.3939L4.80357 5.97773C4.80352 5.97777 4.80348 5.97782 4.80343 5.97786C4.23288 6.53851 3.85409 7.04559 3.67897 7.49873C3.50517 7.94354 3.42083 8.52403 3.42083 9.23522V9.33522H3.52083H4.83669H4.93669V9.23522C4.93669 8.61894 5.00559 8.16742 5.13516 7.87104C5.2702 7.56859 5.56694 7.19014 6.03732 6.73446L6.03736 6.73442C6.68777 6.10372 7.12621 5.61906 7.34492 5.28353C7.57564 4.93721 7.68669 4.49241 7.68669 3.95699C7.68669 3.0693 7.38372 2.3351 6.77584 1.76283C6.17202 1.18475 5.36921 0.9 4.37836 0.9C3.30643 0.9 2.45225 1.23308 1.82857 1.90779C1.20674 2.57557 0.9 3.45679 0.9 4.54099Z',
    },
  ],
});

register('picture', {
  width: 16,
  height: 14,
  paths: [
    {
      d: 'M13.25 0.5H2.75C2.15326 0.5 1.58097 0.737053 1.15901 1.15901C0.737053 1.58097 0.5 2.15326 0.5 2.75V13.25C0.5 13.8467 0.737053 14.419 1.15901 14.841C1.58097 15.2629 2.15326 15.5 2.75 15.5H13.25C13.3734 15.4983 13.4963 15.4857 13.6175 15.4625L13.8425 15.41H13.895H13.9325L14.21 15.305L14.3075 15.2525C14.3825 15.2075 14.465 15.17 14.54 15.1175C14.6401 15.0438 14.7353 14.9636 14.825 14.8775L14.8775 14.81C14.9511 14.7354 15.0188 14.6551 15.08 14.57L15.1475 14.4725C15.1999 14.389 15.245 14.3012 15.2825 14.21C15.3031 14.174 15.3206 14.1364 15.335 14.0975C15.3725 14.0075 15.395 13.91 15.425 13.8125V13.7C15.4675 13.5535 15.4927 13.4024 15.5 13.25V2.75C15.5 2.15326 15.2629 1.58097 14.841 1.15901C14.419 0.737053 13.8467 0.5 13.25 0.5ZM2.75 14C2.55109 14 2.36032 13.921 2.21967 13.7803C2.07902 13.6397 2 13.4489 2 13.25V10.0175L4.4675 7.5425C4.53722 7.4722 4.62017 7.41641 4.71157 7.37833C4.80296 7.34026 4.90099 7.32065 5 7.32065C5.09901 7.32065 5.19704 7.34026 5.28843 7.37833C5.37983 7.41641 5.46278 7.4722 5.5325 7.5425L11.9825 14H2.75ZM14 13.25C13.9993 13.3425 13.9815 13.434 13.9475 13.52C13.9304 13.5566 13.9103 13.5917 13.8875 13.625C13.8674 13.6568 13.8449 13.6868 13.82 13.715L9.8075 9.7025L10.4675 9.0425C10.5372 8.9722 10.6202 8.91641 10.7116 8.87833C10.803 8.84026 10.901 8.82065 11 8.82065C11.099 8.82065 11.197 8.84026 11.2884 8.87833C11.3798 8.91641 11.4628 8.9722 11.5325 9.0425L14 11.5175V13.25ZM14 9.395L12.59 8C12.1608 7.59274 11.5917 7.36571 11 7.36571C10.4083 7.36571 9.83921 7.59274 9.41 8L8.75 8.66L6.59 6.5C6.16079 6.09274 5.59167 5.86571 5 5.86571C4.40833 5.86571 3.83921 6.09274 3.41 6.5L2 7.895V2.75C2 2.55109 2.07902 2.36032 2.21967 2.21967C2.36032 2.07902 2.55109 2 2.75 2H13.25C13.4489 2 13.6397 2.07902 13.7803 2.21967C13.921 2.36032 14 2.55109 14 2.75V9.395Z',
    },
  ],
});

register('headphones', {
  width: 16,
  height: 14,
  paths: [
    {
      d: 'M8 0.25C7.01509 0.25 6.03982 0.443993 5.12987 0.820904C4.21993 1.19781 3.39314 1.75026 2.6967 2.4467C1.29018 3.85322 0.5 5.76088 0.5 7.75V13C0.5 13.1989 0.579018 13.3897 0.71967 13.5303C0.860322 13.671 1.05109 13.75 1.25 13.75H3.5C4.09674 13.75 4.66903 13.5129 5.09099 13.091C5.51295 12.669 5.75 12.0967 5.75 11.5V10C5.75 9.40326 5.51295 8.83097 5.09099 8.40901C4.66903 7.98705 4.09674 7.75 3.5 7.75H2C2 6.1587 2.63214 4.63258 3.75736 3.50736C4.88258 2.38214 6.4087 1.75 8 1.75C9.5913 1.75 11.1174 2.38214 12.2426 3.50736C13.3679 4.63258 14 6.1587 14 7.75H12.5C11.9033 7.75 11.331 7.98705 10.909 8.40901C10.4871 8.83097 10.25 9.40326 10.25 10V11.5C10.25 12.0967 10.4871 12.669 10.909 13.091C11.331 13.5129 11.9033 13.75 12.5 13.75H14.75C14.9489 13.75 15.1397 13.671 15.2803 13.5303C15.421 13.3897 15.5 13.1989 15.5 13V7.75C15.5 5.76088 14.7098 3.85322 13.3033 2.4467C11.8968 1.04018 9.98912 0.25 8 0.25ZM3.5 9.25C3.69891 9.25 3.88968 9.32902 4.03033 9.46967C4.17098 9.61032 4.25 9.80109 4.25 10V11.5C4.25 11.6989 4.17098 11.8897 4.03033 12.0303C3.88968 12.171 3.69891 12.25 3.5 12.25H2V9.25H3.5ZM14 12.25H12.5C12.3011 12.25 12.1103 12.171 11.9697 12.0303C11.829 11.8897 11.75 11.6989 11.75 11.5V10C11.75 9.80109 11.829 9.61032 11.9697 9.46967C12.1103 9.32902 12.3011 9.25 12.5 9.25H14V12.25Z',
    },
  ],
});

register('camera', {
  width: 16,
  height: 10,
  paths: [
    {
      d: 'M15.1475 1.3625C15.0335 1.29667 14.9042 1.26202 14.7725 1.26202C14.6408 1.26202 14.5115 1.29667 14.3975 1.3625L11.75 2.6675C11.7286 2.08518 11.4822 1.53385 11.0625 1.12958C10.6429 0.725304 10.0827 0.499609 9.5 0.500001H2.75C2.15326 0.500001 1.58097 0.737053 1.15901 1.15901C0.737053 1.58097 0.5 2.15326 0.5 2.75V7.25C0.5 7.84674 0.737053 8.41903 1.15901 8.84099C1.58097 9.26295 2.15326 9.5 2.75 9.5H9.5C10.0827 9.50039 10.6429 9.2747 11.0625 8.87042C11.4822 8.46615 11.7286 7.91482 11.75 7.3325L14.42 8.6675C14.5222 8.71991 14.6351 8.74814 14.75 8.75C14.8904 8.75045 15.0281 8.71147 15.1475 8.6375C15.2556 8.56995 15.3447 8.47596 15.4063 8.36442C15.468 8.25288 15.5003 8.12746 15.5 8V2C15.5003 1.87254 15.468 1.74712 15.4063 1.63558C15.3447 1.52404 15.2556 1.43005 15.1475 1.3625ZM10.25 7.25C10.25 7.44891 10.171 7.63968 10.0303 7.78033C9.88968 7.92098 9.69891 8 9.5 8H2.75C2.55109 8 2.36032 7.92098 2.21967 7.78033C2.07902 7.63968 2 7.44891 2 7.25V2.75C2 2.55109 2.07902 2.36032 2.21967 2.21967C2.36032 2.07902 2.55109 2 2.75 2H9.5C9.69891 2 9.88968 2.07902 10.0303 2.21967C10.171 2.36032 10.25 2.55109 10.25 2.75V7.25ZM14 6.785L11.75 5.66V4.34L14 3.215V6.785Z',
    },
  ],
});

register('cloud-upload', {
  width: 60,
  height: 60,
  paths: [
    {
      d: 'M38.7451 33.707C38.9401 33.902 39.1961 34 39.4521 34C39.7081 34 39.9641 33.902 40.1591 33.707C40.5501 33.316 40.5501 32.684 40.1591 32.293L30.1641 22.299C30.0711 22.204 29.9581 22.128 29.8321 22.077C29.7271 22.033 29.6171 22.017 29.5051 22.011C29.4871 22.01 29.4721 22 29.4531 22H29.4521C29.3211 22 29.1911 22.027 29.0681 22.078C28.9921 22.109 28.9311 22.163 28.8661 22.212C28.8261 22.241 28.7801 22.257 28.7441 22.293L18.7441 32.293C18.3531 32.684 18.3531 33.316 18.7441 33.707C19.1351 34.098 19.7671 34.098 20.1581 33.707L28.4531 25.412V59C28.4531 59.552 28.9011 60 29.4531 60C30.0051 60 30.4531 59.552 30.4531 59V25.416L38.7451 33.707ZM23.4531 38H8.45312C5.14412 38 2.45312 35.309 2.45312 32C2.45312 28.691 5.14412 26 8.45312 26C9.00513 26 9.45312 25.552 9.45312 25C9.45312 24.448 9.00513 24 8.45312 24C4.04213 24 0.453125 27.589 0.453125 32C0.453125 36.411 4.04213 40 8.45312 40H23.4531C24.0051 40 24.4531 39.552 24.4531 39C24.4531 38.448 24.0051 38 23.4531 38ZM55.3701 18.193C54.9181 17.875 54.2941 17.983 53.9761 18.433C53.6581 18.884 53.7651 19.508 54.2161 19.827C56.8691 21.702 58.4531 24.757 58.4531 28C58.4531 33.514 53.9671 38 48.4531 38H35.4531C34.9011 38 34.4531 38.448 34.4531 39C34.4531 39.552 34.9011 40 35.4531 40H48.4531C55.0701 40 60.4531 34.617 60.4531 28C60.4531 24.108 58.5531 20.442 55.3701 18.193ZM24.8201 8.207C27.4311 4.32 31.7801 2 36.4531 2C44.1731 2 50.4531 8.28 50.4531 16C50.4531 17.269 50.2841 18.525 49.9501 19.734C49.8031 20.266 50.1161 20.817 50.6481 20.964C50.7371 20.989 50.8271 21 50.9141 21C51.3531 21 51.7561 20.709 51.8781 20.266C52.2601 18.884 52.4531 17.448 52.4531 16C52.4531 7.178 45.2751 0 36.4531 0C31.1121 0 26.1421 2.651 23.1601 7.092C22.8521 7.551 22.9741 8.172 23.4321 8.48C23.8911 8.789 24.5121 8.665 24.8201 8.207ZM4.65212 22.189C4.52012 21.474 4.45312 20.737 4.45312 20C4.45312 13.383 9.83612 8 16.4531 8C19.7661 8 22.8511 9.321 25.1401 11.721C25.5211 12.121 25.5061 12.754 25.1061 13.135C24.7071 13.516 24.0741 13.501 23.6921 13.101C21.7851 11.102 19.2141 10 16.4531 10C10.9391 10 6.45312 14.486 6.45312 20C6.45312 20.615 6.50912 21.23 6.61912 21.826C6.71912 22.369 6.36013 22.891 5.81712 22.991C5.75612 23.002 5.69513 23.008 5.63513 23.008C5.16213 23.008 4.74113 22.671 4.65212 22.189Z',
    },
  ],
});

register('pause', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z',
    },
  ],
});

register('play', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z',
    },
  ],
});

register('add-circle', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z',
    },
  ],
});

register('cancel-outline', {
  width: 22,
  height: 22,
  paths: [
    {
      d: 'M10.9992 0.203125C5.03454 0.203125 0.199219 5.03845 0.199219 11.0031C0.199219 16.9678 5.03454 21.8031 10.9992 21.8031C16.9639 21.8031 21.7992 16.9678 21.7992 11.0031C21.7992 5.03845 16.9639 0.203125 10.9992 0.203125ZM10.9992 2.00313C15.9698 2.00313 19.9992 6.03256 19.9992 11.0031C19.9992 15.9737 15.9698 20.0031 10.9992 20.0031C6.02866 20.0031 1.99922 15.9737 1.99922 11.0031C1.99922 6.03256 6.02866 2.00313 10.9992 2.00313ZM13.4995 7.1847C13.851 6.83323 14.4208 6.83323 14.7723 7.1847C15.1238 7.53618 15.1238 8.10602 14.7723 8.4575L12.2267 11.0031L14.7722 13.5487C15.1237 13.9002 15.1237 14.47 14.7722 14.8215C14.4208 15.173 13.8509 15.173 13.4994 14.8215L10.9539 12.2759L8.40833 14.8215C8.05686 15.1729 7.48701 15.1729 7.13554 14.8215C6.78407 14.47 6.78407 13.9001 7.13554 13.5487L9.68108 11.0031L7.13548 8.45753C6.78401 8.10605 6.78401 7.5362 7.13548 7.18473C7.48695 6.83326 8.0568 6.83326 8.40827 7.18473L10.9539 9.73033L13.4995 7.1847Z',
    },
  ],
});

register('cancel', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
    },
  ],
});

register('cancel-bg', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 11.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z',
      opacity: '.75',
      fill: '#FFF',
    },
    {
      d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z',
    },
  ],
});

register('visibility-off', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z',
    },
  ],
});

register('sort', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z',
    },
  ],
});

register('drag', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    },
  ],
});
